<template>
	<div class="reserve-background-width" style="max-width: 100% !important;  height: 100vh; width:1080px; overflow:auto; min-width:1080px;">
		<div v-if="!keypadInput">
			<v-img
				v-if="eventsData.eventImg"
				:src="$store.state.frontServer_upload + eventsData.eventImg.url"
				@error="imgError()"
				class="imageButton"
			>
				<v-layout class="clickBtn2" wrap justify-center>
					<btn
						:btn="nextbtn"
						:btn_txt="'3블록 중복\n청약 이벤트'"
						:style="`color:${$store.state.PointColor8}; margin-left: 80px !important;`"
						@click="startSurvey('prime')"
					></btn>
					<btn
						class="mr-2"
						:btn="nextbtn"
						:btn_txt="'일반\n청약 이벤트'"
						:style="`color:${$store.state.PointColor8}; margin-right: 80px !important;`"
						@click="startSurvey('nomal')"
					></btn>
				</v-layout>
				<!-- <v-btn @click="print_test()">
					print test
				</v-btn> -->
			</v-img>
			<v-img v-else-if="eventsData.eventImg === null" :src="defaultImg" class="imageButton"> </v-img>
		</div>
		<div v-else>
			<v-img src="/image/keypad_sub2.png" class="imageButton">
				<v-layout wrap class="keypad_main_layout2">
					<v-flex xs12>
						<div class="text-center reserve_keypad_maintxt mt-8 mb-4" style="font-size: 23px;">
							이벤트 참여 결과 및 상품 수령 안내를 위해 성명 및 휴대폰 번호, 생년월일을 입력해 주세요.
						</div>
					</v-flex>
					<v-flex xs12>
						<v-layout wrap>
							<v-flex xs6>
								<div class="white--text title text-left mb-1">
									이름
								</div>
							</v-flex>
							<v-flex xs6 class="pl-4">
								<div class="white--text title text-left mb-1">
									휴대전화번호
								</div>
							</v-flex>
							<v-flex xs6>
								<txtField
									class="placeholder-color-white"
									:txtField="nametxtField"
									v-model="nametxtField.value"
									@input="disableNext()"
								></txtField>
							</v-flex>
							<v-flex xs2 class="pl-4">
								<select-box :sel="numSel" @change="change"></select-box>
							</v-flex>
							<v-flex xs4 class="pl-1">
								<txtField
									class="placeholder-color-white"
									:txtField="numtxtField"
									v-model="numtxtField.value"
									@input="disableNext()"
									@click="clickNumtxtField()"
								></txtField>
							</v-flex>
							<v-flex xs6></v-flex>
							<v-flex xs6 class="pl-4">
								<div class="white--text title text-left mb-1 mt-2">
									생년월일
								</div>
							</v-flex>
							<v-flex xs6></v-flex>
							<v-flex xs6 class="pl-4">
								<txtField
									class="placeholder-color-white"
									:txtField="birthtxtField"
									v-model="birthtxtField.value"
									@click="clickBirthtxtField()"
								></txtField>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs12>
						<v-layout wrap class="mt-4 keypad_background">
							<v-flex xs9>
								<keyboard_kr @onChange="onChange_kr" @onKeyPress="onKeyPress_kr" :input="nametxtField.value" />
							</v-flex>
							<v-flex xs3 class="pl-3" v-if="numSetting">
								<keyboard_number @onChange="onChange_number" :input="numtxtField.value" />
							</v-flex>
							<v-flex xs3 class="pl-3" v-else>
								<keyboard_number @onChange="onChange_birth" :input="birthtxtField.value" />
							</v-flex>
						</v-layout>
					</v-flex>

					<v-flex xs12>
						<v-layout align-center class="mb-1 mt-9">
							<div class="reserve_keypad_subtxt">
								개인정보 수집 및 활용동의
							</div>
							<v-spacer></v-spacer>
							<v-radio-group v-model="agree" column hideDetails dark class="mt-0">
								<v-radio class="radio_label_white" label="개인정보 수집동의" :value="true" color="white"></v-radio>
							</v-radio-group>
						</v-layout>
					</v-flex>
					<v-flex xs12>
						<div class="keypad_agree_content">
							{{ agreeContent }}
						</div>
					</v-flex>

					<v-flex xs12>
						<v-layout align-center justify-center class="mt-8">
							<v-btn class="keypad_btn mr-4" depressed @click="eventInvite()">
								참여 및 등록
							</v-btn>
							<v-btn class="keypad_btn" depressed @click="cancel">
								이전
							</v-btn>
						</v-layout>
					</v-flex>
				</v-layout>
			</v-img>
		</div>
		<v-dialog v-model="check_dialog" width="600" persistent content-class="check_dialog">
			<div class="check_layout">
				<div class="check_title">
					이벤트 참여 완료
				</div>
				<v-layout class="check_sub_layout">
					<div class="check_sub_title" style="width:80px">
						이름
					</div>
					<div class="check_sub_title">
						{{ nametxtField.value }}
					</div>
				</v-layout>
				<v-layout class="check_sub_layout">
					<div class="check_sub_title" style="width:80px">
						전화번호
					</div>
					<div class="check_sub_title">{{ numSel.value }} {{ numtxtField.value }}</div>
				</v-layout>
				<v-layout class="check_sub_layout">
					<div class="check_sub_title" style="width:80px">
						생년월일
					</div>
					<div class="check_sub_title">{{ birthtxtField.value }}</div>
				</v-layout>
				<v-layout class="check_sub_layout">
					<div class="check_sub_title" style="width:80px">
						참여일시
					</div>
					<div class="check_sub_title">
						{{ new Date() | moment('YYYY년 MM월 DD일 HH:mm') }}
					</div>
				</v-layout>
				<v-layout justify-center class="my-4">
					<div class="infoBackground" :style="`background-color:${$store.state.PointColor7}`">
						<v-icon size="40px" color="white">mdi-check </v-icon>
					</div>
				</v-layout>
				<div class="check_info">※확인을 누르시면 화면 하단 출력기에서 응모권이 출력 됩니다. <br /></div>
			</div>
			<v-layout justify-center class="mt-4">
				<v-btn class="check_re_btn mr-4" color="#AAAAAA" dark @click="check_dialog = !check_dialog">
					다시입력
				</v-btn>
				<v-btn class="check_complete" color="#631115" dark @click="complete">
					확인
				</v-btn>
			</v-layout>
		</v-dialog>
		<!-- 드래그 버전 설문 모달 -->
		<reservevisitModalDrag :setdialog="reserveDialog" :title="placeTitle" :eventsData="eventsData"></reservevisitModalDrag>
		<div id="print-background">
			<div id="print">
				<div id="back-setting">
					<div>
						<div style="text-align: right">(고객용)</div>
						<div
							style="text-align: center;
			width: 300px;
			height: auto;
			margin: 0px auto 4px auto;
			border-radius: 40px;
			font-size: 24px;"
						>
							청약이벤트 응모권 <br />
							({{ eventType === 'nomal' ? '일반청약 이벤트' : '더블 X2 응모권' }})
						</div>
						<div style="border: 1px solid black; border-radius: 10px; margin: 0 4px; margin-top: 10px; padding: 4px 0;">
							<div style="text-align: center; font-size: 24px;">{{ nametxtField.value }} 고객님</div>
							<div style="text-align: center; font-size: 24px; margin-top: 4px;">
								{{ numSel.value }}-{{ phoneCrypto(numtxtField.value) }}
							</div>
							<div style="text-align: center; font-size: 24px; margin-bottom: 4px; margin-top: 4px;">
								({{ new Date() | moment('YYYY-MM-DD HH:mm') }})
							</div>
						</div>
						<div style="margin: 0 4px; margin-top: 10px;">
							<div style="text-align: center; font-size: 24px; margin-top: 10px; margin-bottom: 4px;">
								당 첨 경 품
							</div>
							<v-layout v-if="eventType !== 'nomal'">
								<v-flex xs6>
									<div
										style="text-align: center; font-size: 13px; font-weight:bold; margin-top: 4px; padding: 4px 0; border: 1px solid black;"
									>
										3블록 중복청약 이벤트
									</div>
								</v-flex>
								<v-flex xs6>
									<div
										style="text-align: center; font-size: 13px; font-weight:bold; margin-top: 4px; padding: 4px 0; border: 1px solid black;"
									>
										일반 청약 이벤트
									</div>
								</v-flex>
							</v-layout>
							<v-layout v-else>
								<v-flex xs12>
									<div style="text-align: center; font-size: 14px; font-weight:bold; padding: 4px 0; border: 1px solid black;">
										일반 청약 이벤트
									</div>
								</v-flex>
							</v-layout>
							<v-layout v-if="eventType !== 'nomal'">
								<v-flex xs6>
									<div style="text-align: center; font-size: 13px; padding: 4px 0; margin-bottom: 14px; border: 1px solid black;">
										1등 에르메스 벌킨 30<br />
										2등 롤렉스 데이저스트
									</div>
								</v-flex>
								<v-flex xs6>
									<div style="text-align: center; font-size: 13px; padding: 4px 0; margin-bottom: 14px; border: 1px solid black;">
										1등 에르메스 장지갑<br />2등 에르메스 스카프
									</div>
								</v-flex>
							</v-layout>
							<v-layout v-else>
								<v-flex xs12>
									<div style="text-align: center; font-size: 14px; padding: 4px 0; margin-bottom: 14px; border: 1px solid black;">
										1등 에르메스 장지갑<br />2등 에르메스 스카프
									</div>
								</v-flex>
							</v-layout>
						</div>
						<div style="border: 1px solid black; border-radius: 10px; margin: 0 4px; padding: 4px 0; margin-top: 4px;">
							<div style="text-align: center; font-size: 14px;">
								경품발표일 : 5월 18일 (토) 2시 견본주택
							</div>
						</div>

						<div style="max-width: 400px; margin: 10px auto; margin-bottom: 30px;">
							<div style="font-size: 13px; margin-left: 16px;">
								※ 제세공과금 (22%)은 소비자 부담입니다.
							</div>
							<div style="font-size: 13px; margin-left: 16px; margin-top: 4px;">
								※ 1인 1회 응모 가능합니다. <br />
								<span style="margin-left: 16px">
									(중복 응모시 당첨에서 제외 됩니다)
								</span>
							</div>
							<div style="font-size: 13px; margin-left: 16px; margin-top: 4px;">
								{{
									eventType === 'nomal'
										? '※ 입력된 개인정보 불일치시 해당경품은 지급되지 않습니다.'
										: '※ 경품 발표일 참석자에게만 해당경품은 지급됩니다.'
								}}
							</div>
						</div>
					</div>
					<div style="page-break-before:always">
						<div style="text-align: right">(응모용)</div>
						<div style="border:6px dashed black; margin-top:4px;"></div>
						<div
							v-if="eventType === 'nomal'"
							style="text-align: center;
			width: 300px;
			height: auto;
			margin: 0px auto 4px auto;
			border-radius: 40px;
			font-size: 24px;"
						>
							청약이벤트 응모권 <br />
							({{ eventType === 'nomal' ? '일반청약 이벤트' : '3블록 중복청약 이벤트' }})
						</div>
						<div v-else style="display: flex; margin: 4px;">
							<div
								style="text-align: center;
								align-content: center;
								width: 60px;
			height: auto;
			margin: 0px auto 4px auto;
			border: 1px solid black;
			font-size: 24px;"
							>
								3
							</div>
							<div
								style="text-align: center;
			height: auto;
			margin: 0px auto 4px auto;
			border: 1px solid black;
			font-size: 19px;"
							>
								청약이벤트 응모권 <br />
								({{ eventType === 'nomal' ? '일반청약 이벤트' : '3블록 중복청약 이벤트' }})
							</div>
						</div>
						<div style="border: 1px solid black; border-radius: 10px; margin: 0 4px; margin-top: 10px;padding: 4px 0;">
							<div style="text-align: center; font-size: 24px;">{{ nametxtField.value }} 고객님</div>
							<div style="text-align: center; font-size: 24px; margin-top: 4px;">
								{{ numSel.value }}-{{ phoneCrypto(numtxtField.value) }}
							</div>
							<div style="text-align: center; font-size: 24px; margin-bottom: 4px; margin-top: 4px;">
								({{ new Date() | moment('YYYY-MM-DD HH:mm') }})
							</div>
						</div>
						<div style="margin: 0 4px; margin-top: 10px;">
							<div style="text-align: center; font-size: 24px; margin-top: 10px; margin-bottom: 4px;">
								당 첨 경 품
							</div>
							<v-layout>
								<v-flex xs12 v-if="eventType !== 'nomal'">
									<div style="text-align: center; font-size: 13px; font-weight:bold; padding: 4px 0; border: 1px solid black;">
										3블록 중복청약 이벤트
									</div>
								</v-flex>
								<v-flex xs12 v-else>
									<div style="text-align: center; font-size: 13px; font-weight:bold; padding: 4px 0; border: 1px solid black;">
										일반 청약 이벤트
									</div>
								</v-flex>
							</v-layout>
							<v-layout>
								<v-flex xs12 v-if="eventType !== 'nomal'">
									<div style="text-align: center; font-size: 13px; padding: 4px 0; margin-bottom: 14px; border: 1px solid black;">
										1등 에르메스 벌킨 30<br />
										2등 롤렉스 데이저스트
									</div>
								</v-flex>
								<v-flex xs12 v-else>
									<div style="text-align: center; font-size: 13px; padding: 4px 0; margin-bottom: 14px; border: 1px solid black;">
										1등 에르메스 장지갑<br />2등 에르메스 스카프
									</div>
								</v-flex>
							</v-layout>
						</div>
						<div style="border: 1px solid black; border-radius: 10px; margin: 0 4px; margin-top: 4px; padding: 4px 0;">
							<div style="text-align: center; font-size: 14px;">
								경품발표일 : 5월 18일 (토) 2시 견본주택
							</div>
						</div>

						<div style="max-width: 400px; margin: 10px auto; margin-bottom: 30px;">
							<div style="font-size: 13px; margin-left: 16px;">
								※ 제세공과금 (22%)은 소비자 부담입니다.
							</div>
							<div style="font-size: 13px; margin-left: 16px; margin-top: 4px;">
								※ 1인 1회 응모 가능합니다. <br />
								<span style="margin-left: 16px">
									(중복 응모시 당첨에서 제외 됩니다)
								</span>
							</div>
							<div style="font-size: 13px; margin-left: 16px; margin-top: 4px;">
								{{
									eventType === 'nomal'
										? '※ 입력된 개인정보 불일치시 해당경품은 지급되지 않습니다.'
										: '※ 경품 발표일 참석자에게만 해당경품은 지급됩니다.'
								}}
							</div>
						</div>
					</div>
					<div style="page-break-before:always" v-if="eventType !== 'nomal'">
						<div style="text-align: right">(응모용)</div>
						<div style="border:6px dashed black; margin-top:4px;"></div>
						<div
							style="text-align: center;
			width: 300px;
			height: auto;
			
			margin: 0px auto 4px auto;
			border-radius: 40px;
			font-size: 24px;"
						>
							청약이벤트 응모권 <br />
							일반청약 이벤트
						</div>
						<div style="border: 1px solid black; border-radius: 10px; margin: 0 4px; margin-top: 10px; padding: 4px 0;">
							<div style="text-align: center; font-size: 24px;">{{ nametxtField.value }} 고객님</div>
							<div style="text-align: center; font-size: 24px; margin-top: 4px;">
								{{ numSel.value }}-{{ phoneCrypto(numtxtField.value) }}
							</div>
							<div style="text-align: center; font-size: 24px; margin-bottom: 4px; margin-top: 4px;">
								({{ new Date() | moment('YYYY-MM-DD HH:mm') }})
							</div>
						</div>
						<div style="margin: 0 4px; margin-top: 10px;">
							<div style="text-align: center; font-size: 24px; margin-top: 10px; margin-bottom: 4px;">
								당 첨 경 품
							</div>
							<v-layout>
								<v-flex xs12>
									<div
										style="text-align: center; font-size: 14px; font-weight:bold; padding: 4px 0; margin-top: 4px; border: 1px solid black;"
									>
										일반 청약 이벤트
									</div>
								</v-flex>
							</v-layout>
							<v-layout>
								<v-flex xs12>
									<div style="text-align: center; font-size: 14px; padding: 4px 0; margin-bottom: 14px; border: 1px solid black;">
										1등 에르메스 장지갑<br />2등 에르메스 스카프
									</div>
								</v-flex>
							</v-layout>
						</div>
						<div style="border: 1px solid black; border-radius: 10px; margin: 0 4px; margin-top: 4px; padding: 4px 0;">
							<div style="text-align: center; font-size: 14px;">
								경품발표일 : 5월 18일 (토) 2시 견본주택
							</div>
						</div>

						<div style="max-width: 400px; margin: 10px auto; margin-bottom: 30px;">
							<div style="font-size: 13px; margin-left: 16px;">
								※ 제세공과금 (22%)은 소비자 부담입니다.
							</div>
							<div style="font-size: 13px; margin-left: 16px; margin-top: 4px;">
								※ 1인 1회 응모 가능합니다. <br />
								<span style="margin-left: 16px">
									(중복 응모시 당첨에서 제외 됩니다)
								</span>
							</div>
							<div style="font-size: 13px; margin-left: 16px; margin-top: 4px;">
								※ 입력된 개인정보 불일치시 해당경품은 지급되지 않습니다.
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<alertModal5 :setdialog="alertModal" />
		<alertModal5 :setdialog="alertModal2" />
	</div>
</template>

<script>
import { alertModal5, btn, keyboard_kr, keyboard_number, reservevisitModalDrag, selectBox, txtField } from '@/components/index.js'
import Hangul from 'hangul-js'
export default {
	components: {
		btn,
		txtField,
		selectBox,
		keyboard_kr,
		keyboard_number,
		reservevisitModalDrag,
		alertModal5,
	},
	metaInfo() {
		return {
			// 페이지 제목 캠페인 명에 따라 변경
			title: this.campaignTitle,
		}
	},
	data() {
		return {
			eventType: 'nomal',
			winnterProduct: '',
			check_dialog: false,
			agree: false,
			keypadInput: false,
			nametxtField: {
				height: 50,
				value: '',
				solo: true,
				readonly: true,
				label: '이름을 입력하세요',
				dark: false,
				color: 'white',
			},
			numSel: {
				value: '010',
				solo: true,
				class: 'selectNum',
				items: ['010', '011', '016', '017'],
				dark: false,
				color: 'white',
				height: 50,
			},
			birthtxtField: {
				height: 50,
				color: 'white',
				label: '생년월일을 입력해주세요.(ex: 810101)',
				solo: true,
				dark: false,
				type: 'Number',
				value: '',
				onlyNumber: true,
				maxlength: 8,
				maxNumber: true,
				max: 99999999,
				readonly: true,
			},
			numtxtField: {
				height: 50,
				color: 'white',
				label: '휴대전화를 입력하세요',
				solo: true,
				dark: false,
				type: 'Number',
				value: '',
				onlyNumber: true,
				maxlength: 8,
				maxNumber: true,
				max: 99999999,
				readonly: true,
			},
			numSetting: true,
			keyboardData: '',
			defaultImg: require('@/../public/image/default_main.png'),
			placeTitle: '',
			nextbtn: {
				block: false,
				large: true,
				class: 'customBtn2',
				color: this.$store.state.PointColor7,
			},
			backbtn: {
				block: true,
				large: true,
				class: 'selectBtn',
			},
			reserveDialog: {
				title: '예약정보',
				dialog: false,
				step1: true,
				step2: false,
				step3: false,
				name: '',
				inputUserData: {
					name: '',
					phone: '',
				},
			},
			reserveDialog1: {
				title: '예약정보',
				dialog: false,
				step1: true,
				step2: false,
				step3: false,
				name: '',
				inputUserData: {
					name: '',
					phone: '',
				},
			},
			startDialog: {
				step1: true,
				dialog: false,
				nametxtField: {
					value: '',
					outlined: true,
					placeholder: '성명을 입력하세요.',
					color: 'black',
				},
				numSel: {
					value: '010',
					outlined: true,
					class: 'selectNum',
					items: ['010', '011', '016', '017'],
					color: 'black',
				},
				numtxtField: {
					value: '',
					outlined: true,
					placeholder: '숫자만 입력하세요',
					onlyNumber: true,
					maxlength: 8,
					color: 'black',
					max: 99999999,
					type: 'Number',
				},
				phonetxtField: {
					value: '',
					outlined: true,
					placeholder: '문자로 전송된 인증번호를 입력하세요',
					onlyNumber: true,
					maxlength: 6,
					color: 'black',
					max: 99999999,
					type: 'Number',
				},
			},
			trackingCodes: [],
			eventsData: { eventImg: null, business: { QRlogo: null } },
			alertModal: {
				dialog: false,
				text: '이름과 전화번호를 입력해 주세요.',
			},
			alertModal2: {
				dialog: false,
				text: '',
			},
			noInputBox: false,
			campaignTitle: '',
			surveyLegnth: 0,
			agreeContent: '',
			message: '',
			messageData1: {}, // create / update 알림톡 데이터
			messageData4: {}, // 내가받을 알림톡 알림톡 데이터
			nameTxtArray: [],
		}
	},

	async created() {
		await this.reservedays()
	},
	methods: {
		clickNumtxtField() {
			this.numSetting = true
		},
		clickBirthtxtField() {
			this.numSetting = false
		},
		nameCrypto(name) {
			if (name.length === 1) {
				return name
			} else if (name.length === 2) {
				return name.slice(0, 1) + '*'
			} else {
				return name.slice(0, 1) + '*'.repeat(name.length - 2) + name.slice(-1)
			}
		},
		phoneCrypto(data) {
			return data.replace(/\d(?=\d{4})/g, '*')
		},
		print_test() {
			var initBody
			window.onbeforeprint = () => {
				initBody = document.body.innerHTML
				document.getElementById('back-setting').style.backgroundColor = 'black'
				document.body.innerHTML = document.getElementById('print').innerHTML
			}
			window.onafterprint = () => {
				document.getElementById('back-setting').style.backgroundColor = 'white'
				document.body.innerHTML = initBody
			}
			window.print()
			return false
		},
		print() {
			var initBody
			window.onbeforeprint = () => {
				initBody = document.body.innerHTML
				document.getElementById('back-setting').style.backgroundColor = 'black'
				document.body.innerHTML = document.getElementById('print').innerHTML
			}
			window.onafterprint = () => {
				location.reload()
				document.getElementById('back-setting').style.backgroundColor = 'white'
				document.body.innerHTML = initBody
			}
			window.print()
			return false
		},
		complete() {
			if (this.numtxtField.value.length > 6) {
				this.createEventJoin()
			} else {
				this.alertModal2.dialog = true
				this.alertModal2.text = '올바른 전화번호를 입력해주세요.'
			}
		},
		eventInvite() {
			if (!this.agree) {
				this.alertModal.text =
					'개인정보 수집동의을 선택하세요.\n동의 없이 진행시 서비스를 제공해 드릴 수 없다는 점 양해 부탁드리며, 입력하신 개인정보는 경품추첨시에만 사용됨을 알려드립니다.'
				return (this.alertModal.dialog = true)
			}
			if (!this.nametxtField.value) {
				this.alertModal.text = '이름을 입력해주세요.'
				return (this.alertModal.dialog = true)
			}
			if (!this.numtxtField.value) {
				this.alertModal.text = '전화번호를 입력해주세요.'
				return (this.alertModal.dialog = true)
			}
			if (!this.birthtxtField.value) {
				this.alertModal.text = '생년월일을 입력해주세요.'
				return (this.alertModal.dialog = true)
			}
			this.check_dialog = true
		},
		cancel() {
			this.nameTxtArray = []
			this.keypadInput = false
			this.agree = false
			this.nametxtField.value = ''
			this.numSel.value = '010'
			this.numtxtField.value = ''
		},
		terms(id) {
			const data = {
				stat: 1,
				id: id,
			}
			this.$store.dispatch('terms', data).then(res => {
				if (res.data.terms.length > 0) {
					this.agreeContent = res.data.terms[0].content
				}
			})
		},
		onChange_kr() {
			this.nametxtField.value = Hangul.assemble(this.nameTxtArray)
		},
		onKeyPress_kr(button) {
			if (button === '{retry}') {
				this.nametxtField.value = ''
				this.nameTxtArray = []
			} else {
				if (button !== '{bksp}') {
					this.nameTxtArray.push(button)
				} else {
					if (this.nameTxtArray.length > 0) {
						this.nameTxtArray.splice([this.nameTxtArray.length - 1], 1)
						this.nametxtField.value = Hangul.assemble(this.nameTxtArray)
					}
				}
			}
		},
		onChange_number(input) {
			if (input.length < 9) this.numtxtField.value = input
		},
		onChange_birth(input) {
			if (input.length < 7) this.birthtxtField.value = input
		},

		imgError() {
			this.eventsData.eventImg = null
		},
		getLength() {
			let index = this.$store.state.reservedayInputBox.categories.findIndex(e => e.type === 90)
			if (index !== -1) {
				this.surveyLegnth = this.$store.state.reservedayInputBox.categories.length - 1
				this.$store.state.reservedayInputBox.categories.splice(index, 1)
			} else {
				this.surveyLegnth = this.$store.state.reservedayInputBox.categories.length
			}
			let dateIndex = this.$store.state.reservedayInputBox.categories.findIndex(e => e.type === 30)
			if (dateIndex !== -1) {
				this.$store.state.reservedayInputBox.categories.splice(dateIndex, 1)
				this.surveyLegnth--
			}
			let timeIndex = this.$store.state.reservedayInputBox.categories.findIndex(e => e.type === 31)
			if (timeIndex !== -1) {
				this.$store.state.reservedayInputBox.categories.splice(timeIndex, 1)
				this.surveyLegnth--
			}
		},
		createTrackingCode() {
			const data = {
				name: this.startDialog.nametxtField.value,
				phone: this.startDialog.numSel.value + this.startDialog.numtxtField.value,
			}
			this.$store
				.dispatch('createTrackingCode', data)
				.then(res => {
					this.$store.state.trackingCodeId = res.data.createTrackingCode.trackingCode.id
					if (!this.eventsData.population || this.eventsData.population === '설정 해제') {
						if (this.eventsData.accessPhones !== '' && this.Data.accessPhones !== null) {
							this.checkPhone()
						} else {
							this.reserveusers()
						}
					} else {
						this.checkPopulation()
					}
				})
				.catch(() => {})
		},
		async reservedays() {
			const data = {
				code: this.$route.params.code,
			}
			await this.$store
				.dispatch('events', data)
				.then(res => {
					this.eventsData = res.data.events[0]
					if (this.eventsData.business) this.terms(this.eventsData.business.privacyTerm_event)
				})
				.catch(err => {
					console.log(err)
				})
		},

		startSurvey(data) {
			this.eventType = data
			this.keypadInput = true
		},
		change() {
			return {}
		},
		disableNext(data) {
			console.log(data)
			if (this.startDialog.numtxtField.value && this.startDialog.nametxtField.value) {
				this.nextbtn.disabled = false
			} else {
				this.nextbtn.disabled = true
			}
			this.reserveDialog.name = this.startDialog.nametxtField.value
		},
		clickdoneBtn() {
			this.reserveDialog.dialog = false
		},
		checkPhone() {
			let phone = this.startDialog.numSel.value + this.startDialog.numtxtField.value
			let realPhone = phone
				.replace(/[^0-9]/g, '')
				.replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, '$1-$2-$3')
				.replace('--', '-')
			let nameCheck = this.eventsData.accessPhones
				.filter(x => x.name === this.startDialog.nametxtField.value)
				.map(x => x.phone)
				.indexOf(realPhone)
			if (nameCheck !== -1) {
				this.reserveusers()
			} else {
				this.alertModal.text = '해당 서비스의 참여 대상이 아닙니다.'
				this.alertModal.dialog = true
				this.startDialog.dialog = false
			}
		},
		isMobile() {
			const ua = navigator.userAgent
			if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
				return 'tablet'
			} else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
				return 'mobile'
			}
			return 'desktop'
		},
		closePage() {
			window.open('about:blank', '_self').close()
			if (this.isMobile() !== 'desktop') {
				location.href = 'kakaotalk://inappbrowser/close'
			}
		},
		randomItem(item) {
			return item[Math.floor(Math.random() * item.length)]
		},
		shuffle(array) {
			return array.sort(() => Math.random() - 0.5)
		},
		createEventJoin() {
			let data2 = {
				name: this.nametxtField.value,
				phone: this.numSel.value + this.numtxtField.value,
				code: this.eventType === 'nomal' ? this.$route.params.code : 'lucky2',
				age: this.birthtxtField.value,
			}
			if (this.eventsData.input_box !== null) {
				data2['inputBoxId'] = this.eventsData.input_box.id
			}

			this.$store.dispatch('createEventJoin', data2).then(res => {
				if (res.data.createEventJoin.eventJoin.name === '이벤트 종료') {
					this.alertModal2.text = '본 이벤트의 모든 참여가 완료되었습니다.'
					this.alertModal2.dialog = true
				} else if (res.data.createEventJoin.eventJoin.name === '중복번호') {
					this.alertModal2.text = '본 이벤트는 중복 참여가 불가능합니다.'
					this.alertModal2.dialog = true
				} else {
					this.winnterProduct = res.data.createEventJoin.eventJoin.winnterProduct
					setTimeout(() => {
						this.print()
					}, 1000)
				}
				this.$store.state.loading = false
			})
		},
		// 생성 / 수정시 알림톡
		creaetSendMessage() {
			const now = new Date()
			const today = this.$moment(now).format('YYYY년 MM월 DD일 HH:mm')
			if (this.messageData1.message === undefined) {
				this.cancel()
				// 생성 / 수정시 알림톡 tpl_code가 없는 경우
				return
			} else {
				this.messageData1.message = this.messageData1.message.replace(/#{사업지명}/g, this.placeTitle)
				this.messageData1.message = this.messageData1.message.replace(/#{고객명}/g, this.nametxtField.value)
				this.messageData1.message = this.messageData1.message.replace(/#{예약신청일시}/g, today)
				this.messageData1.message = this.messageData1.message.replace(/#{예약일시}/g, today)
				// this.messageData1.message = this.messageData1.message.replace(/#{고객정보}/g, url)
			}
			const data = {
				// 필수값

				code: this.$route.params.code,
				sender: this.messageData1.smssender,
				senderkey: this.messageData1.senderkey,
				tpl_code: this.messageData1.tplCode,
				receiver_1: this.numSel.value + this.numtxtField.value,
				subject_1: this.messageData1.tplCodeStr,
				message_1: this.messageData1.message,
				// 여기까지 필수값
				// apikey: this.$store.state.apikey,
				// userid: this.$store.state.userid,
				recvname_1: this.nametxtField.value,
				failover: 'Y',
				fsubject_1: this.messageData1.tplCodeStr,
				fmessage_1: this.messageData1.message,
				button_1: this.messageData1.button ? this.messageData1.button : '[]',
				pay: this.eventsData.business?.id,
			}
			this.$store
				.dispatch('createSendMessage', data)
				.then(() => {
					this.cancel()
				})
				.catch(() => {})
		},
		// 내가받을 알림톡 알림톡
		messages() {
			const data = {
				// tplCode: this.$store.state.reservedayTplCode,
			}
			this.$store
				.dispatch('messages', data)
				.then(res => {
					let foundIndex1 = res.data.messages.findIndex(obj => {
						return obj.tplCode === this.$store.state.reservedayData.tplCode[1]
					})
					if (foundIndex1 !== -1) {
						this.messageData1 = res.data.messages[foundIndex1] // create / update 알림톡 데이터
					}
					this.creaetSendMessage()
				})
				.catch(() => {})
		},
	},
}
</script>

<style lang="scss">
@page {
	size: auto; /* auto is the initial value */
	margin: 5mm; /* this affects the margin in the printer settings */
}

#print-background {
	padding: 0 16px;
	max-width: 298.6px;
	width: 100vh;
	height: 100vh;
	background-color: white;
	display: none;
}
#print {
	display: none;
}
.check_re_btn {
	width: 200px !important;
	height: 45px !important;
}
.check_complete {
	width: 200px !important;
	height: 45px !important;
}
.infoBackground {
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 50%;
	min-width: 90px;
	min-height: 90px;
	margin-bottom: 10px;
	.infoYear {
		background-color: white;
		color: black;
		font-size: 14px;
		border-radius: 10px 10px 0px 0px;
	}
	.infoHour {
		font-size: 14px;
		font-weight: 100;
	}
}
.check_dialog {
	padding: 20px;
	background-color: #ececec;
	.check_layout {
		background-color: white;
		border-radius: 10px;
		padding: 20px;
		.check_sub_layout {
			padding-left: 100px;
		}
		.check_title {
			text-align: center;
			font-size: 47px;
			font-weight: bold;
			color: #631115;
		}
		.check_sub_title {
			font-size: 18px;
			font-weight: bold;
			color: #631115;
		}
		.check_info {
			font-size: 17px;
			padding-left: 35px;
			color: #707070;
		}
	}
}
.radio_label_white {
	label {
		color: white !important;
	}
}
.keypad_btn {
	min-width: 230px !important;
	height: 69px !important;
	color: #631115 !important;
	font-weight: bold !important;
	border-radius: 15px !important;
	font-size: 26px !important;
}
.keypad_background {
	background-color: rgba(255, 255, 255, 0.43);
	border-radius: 18px;
	padding: 8px;
}

.placeholder-color-white {
	.v-input__control {
		.v-input__slot {
			.v-text-field__slot {
				input {
					font-size: 24px !important;
				}
			}
		}
	}
}
.keypad_agree_content {
	border: 1px solid;
	border-color: rgba(255, 255, 255, 0.5);
	border-radius: 15px;
	white-space: break-spaces;
	color: white;
	font-size: 11px;
	padding: 8px;
	text-align: left;
	height: auto;
	max-height: 276px;
	overflow: auto;
}
.reserve_keypad_maintxt {
	font-size: 24px;
	font-weight: bold;
	color: white;
}
.reserve_keypad_subtxt {
	font-size: 20px;
	color: white;
}
.reserve-background-width {
	width: 100%;
	max-width: 600px;
	margin: 0 auto;
}
.imageButton {
	height: 100vh;
	.v-responsive__content {
		position: relative;
		.keypad_main_layout {
			padding: 0 28px;
			position: absolute;
			top: 810px;
		}
		.keypad_main_layout2 {
			max-width: 1040px;
			padding: 0 28px;
			position: absolute;
			top: 350px;
		}
		.clickBtn {
			position: absolute;
			bottom: 178px;
			width: 100%;
			button {
				background-color: #721625 !important;
				height: 80px;
				font-size: 30px !important;
				font-weight: bold !important;
				margin: 0 auto !important;
				min-width: 100px !important;
				width: 700px;
				border-radius: 15px !important;
			}
		}
		.clickBtn2 {
			position: absolute;
			bottom: 90px;
			width: 100%;
			button {
				white-space: break-spaces;
				background-color: #382526 !important;
				height: 150px;
				font-size: 40px !important;
				font-weight: bold !important;
				margin: 0 auto !important;
				width: 100%;
				max-width: 420px;
				border-radius: 15px !important;
			}
		}
	}
	text-align: end;
	padding: 20px;
}
.startVisit {
	background: white !important;
	padding: 20px 0px;
}
.cardTitle {
	font-size: 18px;
	font-weight: bold;
	text-align: center;
}
.guide {
	font-size: 13px;
	font-weight: bold;
	color: #606060;
}
.dialogBottom {
	.title {
		height: 50px;
		display: flex;
		align-items: center;
		text-align: center;
		background-color: #fdc85a;
		padding: 0 10px 0 30px;

		h2 {
			color: white;
			font-weight: bold;
			font-size: 18px;
		}

		.title-icon {
			color: white;
		}
	}
	.dialog-content {
		padding: 20px 20px 20px 20px;
	}
}
.hiddenTab {
	display: none;
}
</style>
<style lang="scss" scoped>
.reserveInfo {
	font-size: 14px;
	font-weight: bold;
	padding: 16px 16px 0px;
	color: #808080;
}
.duplicateInfo {
	font-size: 15px;
	margin-left: 16px;
	color: #808080;
}
</style>
